"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: 600;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 14px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &&& {\n    border-radius: 0;\n    margin: 0;\n    flex: 1;\n    padding: 10px;\n    align-self: stretch;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 92px;\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PlanOption = (0, _styledComponents.default)(_UISelectableBox.default).withConfig({
  displayName: "PlanButton__PlanOption",
  componentId: "sc-16yycvu-0"
})(_templateObject());

var PlanText = _styledComponents.default.div.withConfig({
  displayName: "PlanButton__PlanText",
  componentId: "sc-16yycvu-1"
})(_templateObject2());

var Plan = _styledComponents.default.div.withConfig({
  displayName: "PlanButton__Plan",
  componentId: "sc-16yycvu-2"
})(_templateObject3());

function PlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition,
      selected = _ref.selected,
      onSelectedChange = _ref.onSelectedChange;
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var calculatePriceAndItemConfig = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculatePriceAndItemConfigSelector);
  var price = calculatePriceAndItemConfig({
    merchandiseId: merchandiseId
  }).monthly.calculatedPrice;
  return _react.default.createElement(PlanOption, {
    selected: selected,
    onSelectedChange: onSelectedChange,
    "data-selected": selected,
    "data-selenium-class": "plan-button-" + edition
  }, _react.default.createElement(PlanText, null, _react.default.createElement(Plan, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.edition." + edition
  })), _react.default.createElement("div", null, _react.default.createElement(_PriceDisplay.default, {
    price: price,
    currencyCode: currencyCode
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonthFull"
  }))));
}

var _default = PlanButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/PlanButton.js
// module id = 250
// module chunks = 5 6